import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { PageEmptyState } from '@aslanpay/portal-common-lib';

function TimerIcon(props: React.ComponentProps<typeof Icon>) {
  return (
    <Icon viewBox="0 0 50 50" fill="none" {...props}>
      <path
        d="M25 28.6462C24.1458 28.6462 23.4375 27.9378 23.4375 27.0837V16.667C23.4375 15.8128 24.1458 15.1045 25 15.1045C25.8542 15.1045 26.5625 15.8128 26.5625 16.667V27.0837C26.5625 27.9378 25.8542 28.6462 25 28.6462Z"
        fill="currentColor"
      />
      <path
        d="M25.0007 47.3958C14.084 47.3958 5.20898 38.5208 5.20898 27.6042C5.20898 16.6875 14.084 7.8125 25.0007 7.8125C35.9173 7.8125 44.7923 16.6875 44.7923 27.6042C44.7923 28.4583 44.084 29.1667 43.2298 29.1667C42.3756 29.1667 41.6673 28.4583 41.6673 27.6042C41.6673 18.4167 34.1882 10.9375 25.0007 10.9375C15.8132 10.9375 8.33398 18.4167 8.33398 27.6042C8.33398 36.7917 15.8132 44.2708 25.0007 44.2708C25.8548 44.2708 26.5632 44.9792 26.5632 45.8333C26.5632 46.6875 25.8548 47.3958 25.0007 47.3958Z"
        fill="currentColor"
      />
      <path
        d="M31.25 5.72949H18.75C17.8958 5.72949 17.1875 5.02116 17.1875 4.16699C17.1875 3.31283 17.8958 2.60449 18.75 2.60449H31.25C32.1042 2.60449 32.8125 3.31283 32.8125 4.16699C32.8125 5.02116 32.1042 5.72949 31.25 5.72949Z"
        fill="currentColor"
      />
      <path
        d="M33.6452 45.8754C32.916 45.8754 32.2493 45.7087 31.6452 45.3545C30.2702 44.5629 29.4785 42.9587 29.4785 40.9587V36.1462C29.4785 34.1462 30.2702 32.542 31.6452 31.7504C33.0202 30.9587 34.791 31.0837 36.5202 32.0629L40.6869 34.4795C42.416 35.4795 43.416 36.9587 43.416 38.542C43.416 40.1254 42.416 41.6045 40.6869 42.6045L36.5202 45.0212C35.5619 45.5837 34.5827 45.8754 33.6452 45.8754ZM33.666 34.3337C33.4993 34.3337 33.3327 34.3754 33.2077 34.4379C32.8327 34.6462 32.6035 35.292 32.6035 36.1254V40.9379C32.6035 41.7712 32.8327 42.417 33.2077 42.6254C33.5827 42.8337 34.2494 42.7295 34.9577 42.3129L39.1244 39.8962C39.8535 39.4795 40.291 38.9587 40.291 38.542C40.291 38.1254 39.8535 37.6045 39.1244 37.1879L34.9577 34.7712C34.4785 34.4795 34.0202 34.3337 33.666 34.3337Z"
        fill="currentColor"
      />
    </Icon>
  );
}

function RecognitionInsightsEmpty() {
  return (
    <Flex
      bg="brand.lightGray2"
      borderRadius="10px"
      border="1px solid"
      borderColor="brand.lightGray1"
      w="full"
      p="20px 30px"
      flexDir="column"
      gap="20px"
    >
      <Flex flexDir="column" gap="4px">
        <Text fontSize="24px" fontWeight="600" lineHeight="1.4" color="brand.mutedPurple">
          Recognition insights
        </Text>
        <Text textStyle="smallMedium" color="brand.darkGray">
          Most recognised and engaged employees, and engagement by pride and pot will appear here
          soon!
        </Text>
      </Flex>
      <Box h="330px" w="full">
        <PageEmptyState
          icon={<TimerIcon boxSize="50px" color="#AF9AEC" />}
          title="Things are just getting started"
          description="Recognition insights will appear here once people begin sending recognitions."
        />
      </Box>
    </Flex>
  );
}

export default RecognitionInsightsEmpty;
